import Vue from 'vue'
import moment from 'moment'

Vue.filter('formatDate', (value, format = 'L') => {
  if (value) {
    return moment(String(value)).format(format)
  }
})
